import { LOCATION_AGENCY_RESOURCE } from '../api/resources';
import { createResourceSlice } from '../store/resource/createResourceSlice';

const locationAgenciesSlice = createResourceSlice({
    resource: LOCATION_AGENCY_RESOURCE,
    byKey: ['locationId', 'agencyId'],
});

export const {
    indexFulfilled,
    showFulfilled,
    storeFulfilled,
    updateFulfilled,
    destroyFulfilled,

    indexLocationAgencies,
    showLocationAgency,
    storeLocationAgency,
    updateLocationAgency,
    archiveLocationAgency,
    restoreLocationAgency,
    destroyLocationAgency,
} = locationAgenciesSlice.actions;

export const {
    selectLocationAgencyById,
    makeLocationAgenciesByIdsSelector,
    selectAllLocationAgencyIds,
    selectAllLocationAgencies,
    selectLocationAgenciesLoading,
    selectLocationAgenciesInitialized,
    selectLocationAgencyLoading,
    selectLocationAgencyInitialized,
    selectLocationAgencyIdsByLocationId,
    makeLocationAgencyByLocationIdSelector,
    selectLocationAgencyLoadingByLocationId,
    selectLocationAgencyInitializedByLocationId,
    selectLocationAgencyByLocationIdAndAgencyId,
} = locationAgenciesSlice.selectors;

export const { useLocationAgencies, useLocationAgency, useLocationAgenciesByLocationId} = locationAgenciesSlice.hooks;

export default locationAgenciesSlice.reducer;
